import BaseType from './Base';
import NullableObjectType from './NullableObject';

export default {
  ...NullableObjectType,
  dumpTo(key) {
    return `${key}Id`;
  },
  dump(value) {
    return value.id;
  },
  loadErrors: BaseType.loadErrors,
};



// WEBPACK FOOTER //
// ./mixins/Form/Types/Reference.js